export enum TimerType {
  CountDown = 'count-down',
  CountUp = 'count-up',
  Clock = 'clock',
  None = 'none',
}
